import { rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';

enum OutputFileFormat {
  csv = 'CSV',
  csvForFileImport = 'CSV_FOR_FILE_IMPORT',
}

const outputFileFormatMap = new Map([
  ['CSV', OutputFileFormat.csv],
  ['CSV_FOR_FILE_IMPORT', OutputFileFormat.csvForFileImport],
]);

function rawValueToOutputFileFormat(rawValue: string) {
  return rawValueToEnumWithDefault(outputFileFormatMap, OutputFileFormat.csv)(rawValue);
}

export { OutputFileFormat, outputFileFormatMap, rawValueToOutputFileFormat };
